import * as React from 'react';

import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { ConfigFieldValidation } from '../validation/ConfigurableItemValidator';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useFieldState } from 'informedv4';
import { inputClasses } from '../validation/ValidationClasses';
import { TextArea } from './TextAreaV4';
import * as classNames from 'classnames';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { useReferenceContextProvider } from '../../Core/ReferenceContextProvider';

interface ConfigFieldTextAreaProps {
    id: string;
    field: string;
    name: string;
    className: string;
    disabled?: boolean;
    hidden?: boolean;
    validated: boolean;
    required?: boolean;
    itemId: ConfigurableDataItemIds;
    isInputAddon?: boolean;
    inputAddon?: React.ReactNode;
    type?: string;
    autoComplete?: string;
    onBlur?: any;
}

export const ConfigFieldTextArea = (props: ConfigFieldTextAreaProps): JSX.Element => {
    const {
        id,
        name,
        field,
        className,
        disabled,
        hidden,
        validated,
        required,
        itemId,
        isInputAddon,
        inputAddon,
        type,
        autoComplete,
        onBlur
    } = props;

    const fieldName = field ?? name;
    if (!fieldName) {
        throw new Error("TextBox requires either `field` or `name`.");
    }
    const { error } = useFieldState(fieldName);
    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();
    const { unitTypes } = useReferenceContextProvider();

    const fieldState = useFieldState(field);

    if (dataItemConfigurationCollection === null || dataItemConfigurationCollection === undefined)
        throw 'Fields Configurations is not set';

    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <div className={className} hidden={hidden} data-automationid={`${id}-form-group`}>
                <label htmlFor={id}>{item.displayText}</label>
                <TextArea
                    name={name}
                    id={id}
                    field={field}
                    className={classNames(inputClasses(error as string), className)}
                    validate={ConfigFieldValidation(item, required, validated)}
                    disabled={disabled}
                    type={type}
                    autoComplete={autoComplete}
                    onBlur={onBlur}
                    inputAddon={isInputAddon && inputAddon === undefined ? unitTypes.find(ut => ut.id === item.unitTypeId)?.name : inputAddon}
                />
            </div>
        </Condition>
    </>
}
